import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

export const Route = createFileRoute("/partners/referral-terms")({
  loader: async () => { await setEdgeHtmlCache({ sMaxAge: 1800 }); },
  head: () => buildHead({
    locale: "en",
    title: "Referral Program Terms · Shugert",
    description: "Terms governing the Shugert referral partner program operated by Tech Ventures USA LLC dba Shugert Marketing.",
    path: "/partners/referral-terms",
    altPath: alternatePath("/partners/referral-terms", "es"),
    jsonLd: breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Referral partners", path: "/partners/referrals" }, { name: "Program terms", path: "/partners/referral-terms" }]),
  }),
});
